import React, { useRef, useEffect } from 'react';
import * as echarts from 'echarts/core';
import { View } from 'react-native';
import ViewShot from 'react-native-view-shot';
import SvgChart from '@wuba/react-native-echarts/svgChart';

interface EChartsComponentProps {
  chartOptions: any;
  width: number;
  height: number;
  onCapture: (base64: string) => void;
}

const EChartsCaptureComponent: React.FC<EChartsComponentProps> = ({
  chartOptions,
  width,
  height,
  onCapture,
}) => {
  const viewShotRef = useRef<ViewShot>(null);
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chartRef.current) {
      const chart = echarts.init(chartRef.current, 'light', {
        renderer: 'svg',
        width: width,
        height: height,
      });
      chart.setOption({ ...chartOptions, animation: false });
    }
  }, [chartOptions, width, height]);

  useEffect(() => {
    const captureChart = async () => {
      if (viewShotRef.current) {
        try {
          const uri = await viewShotRef.current.capture?.();
          onCapture(`data:image/png;base64,${uri}`);
        } catch (error) {
          console.error('Error capturing chart:', error);
        }
      }
    };

    const timer = setTimeout(captureChart, 600);
    return () => clearTimeout(timer);
  }, [onCapture]);

  return (
    <View style={{ position: 'absolute', left: -9999 }}>
      <ViewShot
        ref={viewShotRef}
        options={{ format: 'png', quality: 1, result: 'base64' }}
        style={{ width, height }}
      >
        <SvgChart ref={chartRef} />
      </ViewShot>
    </View>
  );
};

export default EChartsCaptureComponent;
